import { render, staticRenderFns } from "./QCharityName.vue?vue&type=template&id=2d565dde&scoped=true&"
import script from "./QCharityName.vue?vue&type=script&lang=js&"
export * from "./QCharityName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d565dde",
  null
  
)

export default component.exports